import { TappInput, TappInputBaseType, TappInputProps } from '@/components/ui/TappInput/Input';
import { InferBaseHtmlType } from '@/components/ui/utils';
import { useNavigateSearch } from 'src/components/ui/hooks/navigate-search.hook';
import React, { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export type TappInputFilterProps = { name: string } & TappInputProps;

const TappInputFilter = React.forwardRef<InferBaseHtmlType<TappInputBaseType>, TappInputFilterProps>(
  ({ name, ...props }, forwardedRef) => {
    const navigate = useNavigateSearch();
    const [searchParams] = useSearchParams();

    const currentValue = useMemo(() => {
      const param = searchParams.get(name);
      if (!param) return '';
      return param;
    }, [searchParams]);

    const onValueChange: React.FormEventHandler<HTMLInputElement> = (event) => {
      const params: Record<string, string | null> = {};
      const value = event.currentTarget.value;

      if (!value) {
        params[name] = null;
      } else {
        params[name] = value;
      }

      navigate({
        params,
        paramsHandling: 'merge',
      });
    };

    return (
      <TappInput ref={forwardedRef} type="text" value={currentValue} onInput={(e) => onValueChange(e)} {...props} />
    );
  }
);

TappInputFilter.displayName = 'TappInputFilter';
export { TappInputFilter };
